import { createAsyncThunk } from '@reduxjs/toolkit';

export interface ClientListItem {
  idp: string;
  uuid: string;
  name: string;
  email: string;
  etag: string;
  lastModified?: string;
}

interface FetchClientsResponse {
  clients: ClientListItem[];
  count: number;
}

/**
 * Fetch list of all clients
 * Returns array of client metadata
 */
export const fetchClientsThunk = createAsyncThunk<ClientListItem[]>(
  'clients/fetchClients',
  async () => {
    console.log('[Clients] Fetching clients list...');
    
    const response = await fetch('/api/clients');
    
    if (!response.ok) {
      throw new Error(`Failed to fetch clients: ${response.status}`);
    }
    
    const data: FetchClientsResponse = await response.json();
    console.log(`[Clients] Fetched ${data.count} clients`);
    return data.clients;
  }
);
